import React, { Fragment } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import Button from 'components/theme/Button'
import { stepperIncrease, stepperGoTo } from 'actions/view'
import { withRouter } from 'react-router-dom'
import { Hidden, IconButton } from '@material-ui/core'
import { ArrowForwardIos, Save, Done } from '@material-ui/icons'
import { addOrUpdateForm, readSignupForm } from 'actions/signupForm'
import { create, read } from 'actions/data'
import { receiveForm } from 'actions/signupForm/addOrEdit'
import { receiveForm as receiveCustomForm } from 'actions/customForm/addOrEdit'
import {
	addOrUpdateCustomForm,
	createCustomIntegration,
	updateCustomIntegration,
} from 'actions/customForm'

export default withRouter(
	connect(
		(state, { stepsLength }) => ({
			stepper: state.view.stepper.form,
			anyChanged:
				state.signupForm.addOrEdit.changed.anyChanged ||
				state.customForm.addOrEdit.anyChanged,
			formID: state.signupForm.addOrEdit.formID,
			formTypeSelected: state.signupForm.addOrEdit.formTypeSelected,
		}),
		(dispatch) =>
			bindActionCreators(
				{
					stepperIncrease,
					receiveForm,
					readSignupForm,
					addOrUpdateForm,
					create,
					receiveCustomForm,
					addOrUpdateCustomForm,
					read,
					stepperGoTo,
					createCustomIntegration,
					updateCustomIntegration,
				},
				dispatch,
			),
	)(
		({
			stepper,
			stepsLength,
			stepperIncrease,
			anyChanged,
			formID,
			history,
			addOrUpdateForm,
			receiveForm,
			readSignupForm,
			formTypeSelected,
			receiveCustomForm,
			addOrUpdateCustomForm,
			read,
			stepperGoTo,
			createCustomIntegration,
			updateCustomIntegration,
		}) => {
			const button = (size, fontSize) => {
				const create = size === 'small' ? <Done /> : 'Create'
				const update = size === 'small' ? <Save /> : 'Update'
				const next = size === 'small' ? <ArrowForwardIos /> : 'Next'

				const ButtonComponent = size === 'small' ? IconButton : Button

				const buttonDisabled =
          stepper === stepsLength - 1 ||
          (formID === 'new' &&
            (!formTypeSelected || (stepper === 1 && !anyChanged))) /*  ||
							(formTypeSelected === 'customIntegration' && !anyChanged) */

        return (
          <ButtonComponent
            style={{
              fontSize,
              padding: size === 'small' ? 5 : undefined,
              marginTop: 3,
              color: '#fff',
              backgroundColor: buttonDisabled
                ? 'gray'
                : anyChanged && stepper !== 0 /*  ||
                    (stepper === 0 && formTypeSelected === 'customIntegration') */
                ? '#18b940'
                : '#014c94',
            }}
            disabled={buttonDisabled}
            variant="contained"
            color="secondary"
            onClick={() => {
              if (
                anyChanged &&
                stepper !== 0 /*  ||
                  (stepper === 0 && formTypeSelected === 'customIntegration') */
              ) {
                if (formTypeSelected === 'custom') {
                  if (formID !== 'new') {
                    addOrUpdateCustomForm(formID).then(payload => {
                      if (payload) {
                        receiveCustomForm(payload).then(() =>
                          read(formID, 'customform').then(newPayload =>
                            receiveCustomForm(newPayload),
                          ),
                        )
                      }
                    })
                  } else {
                    addOrUpdateCustomForm(formID).then(payload => {
                      if (payload) {
                        history.replace(
                          `/forms/${formTypeSelected}/${payload.id}`,
                        )
                        receiveCustomForm(payload).then(() =>
                          read(payload.id, 'customform').then(newPayload =>
                            receiveCustomForm(newPayload),
                          ),
                        )
                      }
                    })
                  }
                } else if (formTypeSelected === 'customIntegration') {
                  if (formID !== 'new') {
                    updateCustomIntegration(formID).then(payload => {
                      if (payload?.id) {
                        read(payload.id, 'customform').then(readPayload => {
                          receiveCustomForm(readPayload)
                          history.replace(
                            `/forms/${formTypeSelected}/${payload.id}`,
                          )
                        })
                      }
                    })
                  } else {
                    createCustomIntegration().then(payload => {
                      if (payload?.id) {
                        read(payload.id, 'customform').then(readPayload => {
                          receiveCustomForm(readPayload)
                          history.replace(
                            `/forms/${formTypeSelected}/${payload.id}`,
                          )
                        })
                      }
                    })
                  }
                } else {
                  if (formID !== 'new') {
                    addOrUpdateForm(formID).then(payload => {
                      if (payload) {
                        receiveForm(payload).then(() =>
                          readSignupForm(formID).then(newPayload =>
                            receiveForm(newPayload),
                          ),
                        )
                      }
                    })
                  } else {
                    addOrUpdateForm(formID).then(payload => {
                      if (payload) {
                        history.replace(
                          `/forms/${formTypeSelected}/${payload.id}`,
                        )
                        receiveForm(payload).then(() =>
                          readSignupForm(payload.id).then(newPayload =>
                            receiveForm(newPayload),
                          ),
                        )
                      }
                    })
                  }
                }
              } else {
                if (stepper === 0 && formID === 'new') {
                  history.replace(`/forms/${formTypeSelected || 'unknown'}/new`)
                }
                // if (formTypeSelected === 'customIntegration' && stepper === 0) {
                //   stepperGoTo(2, 'form')
                // } else {
                stepperIncrease('form')
                // }
              }
            }}
          >
            {anyChanged && /*(*/ stepper !== 0 /*  ||
							(stepper === 0 && formTypeSelected === 'customIntegration') )*/
              ? formID !== 'new'
                ? update
                : create
              : next}
          </ButtonComponent>
        )
			}

			return (
				<Fragment>
					<Hidden smDown>{button('medium')}</Hidden>
					<Hidden mdUp>{button('small', 8)}</Hidden>
				</Fragment>
			)
		},
	),
)
